import axios from "axios";

export function getAllCredentialTypes() {
  return axios("/api/Credentials/credentialTypes", {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  });
}